import React from 'react';
import { IconButton } from '@mui/material';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import theme from '../../theme';

const BookmarkButton = ({ isBookmarked, onToggle, sx = {}, iconSx = {} }) => {
  const IconComponent = isBookmarked ? BookmarkIcon : BookmarkBorderIcon;

  return (
    <IconButton
      disableRipple
      onClick={onToggle}
      aria-label="toggle bookmark"
      sx={{
        width: { xs: 32, md: 40 },
        height: { xs: 32, md: 40 },
        p: 1,
        border: `1px solid ${theme.palette.grey.line}`,
        borderRadius: 1,
        ...sx,
      }}
    >
      <IconComponent
        sx={{
          width: { xs: 16, md: 24 },
          height: { xs: 16, md: 24 },
          ...iconSx,
        }}
      />
    </IconButton>
  );
};

export default BookmarkButton;
